import React, { FC, useState } from "react";
import { TGalleryProps } from "../../types/ContentHubSeriesDetails.type";
import { Carousel as ReactResponsiveCarousel } from "react-responsive-carousel";
import useMediaQuery from "../../../../lib/custom-hooks/useMediaQuery";
import CustomArrow from "../../../../react-only-components/CarouselArrow";
import HeroCarouselIndicator from "../../../HeroCarousel/HeroCarouselIndicator";

const Gallery: FC<TGalleryProps> = ({ assets, hasFixedAspectRatio }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const goToPreviousSlide = () => setCurrentSlide(currentSlide - 1);
  const goToNextSlide = () => setCurrentSlide(currentSlide + 1);
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <>
      <ReactResponsiveCarousel
        infiniteLoop={true}
        onChange={(slideIndex) => setCurrentSlide(slideIndex)}
        selectedItem={currentSlide}
        showThumbs={false}
        showArrows={false}
        showIndicators={false}
        showStatus={false}
      >
        {(assets || []).map((image, index) => {
          const src = isMobile ? image.full : image.full;
          const alt = isMobile ? image.alt : image.alt;
          return (
            <div
              className={`component-details__image-wrapper ${
                hasFixedAspectRatio
                  ? "component-details__image-wrapper--16-9"
                  : ""
              }`}
              key={index}
            >
              <img className="component-details__image" alt={alt} src={src} />
            </div>
          );
        })}
      </ReactResponsiveCarousel>
      {!isMobile ? (
        <>
          <CustomArrow
            className="component-details__arrow component-details__arrow--prev"
            onClick={goToPreviousSlide}
            direction="previous"
          />
          <CustomArrow
            className="component-details__arrow component-details__arrow--next"
            onClick={goToNextSlide}
            direction="next"
          />
        </>
      ) : (
        <ul className={"controls__dots custom"}>
          {(assets || []).map((_, index) => (
            <HeroCarouselIndicator
              baseClassName={"controls__dots__item"}
              index={index}
              key={index}
              isSelected={index == currentSlide}
            />
          ))}
        </ul>
      )}
    </>
  );
};

export default Gallery;
